import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class ModalLarge extends Component {
  render(){

    return(
      <div className={`modal-overlay dark ${this.props.modalClass}`}>

        <div className={`modal-container modal-large ${this.props.modalClass}`} id="modal1">
            <div className="modal-header">
                <h3 className="no-margin">{this.props.title}</h3>
                <Link onClick={this.props.toggleModal} className="modal close" to="/"><i className="fa fa-times fa-lg" aria-hidden="true"></i></Link>
            </div>
            <div className="modal-content">
                {this.props.children}
            </div>
        </div>
      </div>
    );
  }
}
export default ModalLarge;


// WEBPACK FOOTER //
// ./src/components/blocks/ModalLarge.js